import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55f98042"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "info"
};
const _hoisted_2 = {
  class: "info__imgwrapper"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "info__title"
};
const _hoisted_5 = {
  class: "info__text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "info__img",
    src: $props.imgUrl,
    alt: "picture"
  }, null, 8, _hoisted_3)]), _createElementVNode("h6", _hoisted_4, _toDisplayString($props.title), 1), _createElementVNode("p", _hoisted_5, _toDisplayString($props.description), 1), $setup.historyOrder > 83700 ? (_openBlock(), _createBlock(_component_app_button, {
    key: 0,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('repeatOrder')),
    class: "info__btn"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.button_1), 1)]),
    _: 1
  })) : _createCommentVNode("", true), $setup.historyOrder > 83700 ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('historyOrders')),
    class: "info__btn info__btn-history"
  }, _toDisplayString($props.button_2), 1)) : _createCommentVNode("", true)]);
}